/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {LicenseFeatureModule} from '../models/LicenseFeatureModule';

export interface GetDefaultLicenseFeatureModules$Request {
    licenseTypeCode: string;
    accountId: number;
}

export interface GetDefaultLicenseFeatureModules$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getDefaultLicenseFeatureModulesRequest = createAction<PayloadData<void, GetDefaultLicenseFeatureModules$Request>>('GET_DEFAULT_LICENSE_FEATURE_MODULES__GET_DEFAULT_LICENSE_FEATURE_MODULES__REQUEST');
export const getDefaultLicenseFeatureModulesSuccess = createAction<PayloadData<Array<LicenseFeatureModule>, GetDefaultLicenseFeatureModules$Request>>('GET_DEFAULT_LICENSE_FEATURE_MODULES__GET_DEFAULT_LICENSE_FEATURE_MODULES__SUCCESS');
export const getDefaultLicenseFeatureModulesFailure = createAction<PayloadData<Error, GetDefaultLicenseFeatureModules$Request, true>>('GET_DEFAULT_LICENSE_FEATURE_MODULES__GET_DEFAULT_LICENSE_FEATURE_MODULES__FAILURE');

export const getDefaultLicenseFeatureModulesActions = [
    getDefaultLicenseFeatureModulesRequest,
    getDefaultLicenseFeatureModulesSuccess,
    getDefaultLicenseFeatureModulesFailure
] as const;

/**
 * @param {string} meta.licenseTypeCode License Type Code
 * @param {number} meta.accountId Account id
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getDefaultLicenseFeatureModules = (meta: GetDefaultLicenseFeatureModules$Request, config?: GetDefaultLicenseFeatureModules$Config) => {
    const TRANSPORT_GET_PARAMS = {
        licenseTypeCode: meta.licenseTypeCode,
        accountId: meta.accountId,
    };
    return {
        CALL_API: {
            types: getDefaultLicenseFeatureModulesActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/dictionaries/license-feature-modules/default`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

